import Monitoring from '@/Monitoring';
import EventTracker from '@/utils/EventTracker';
import { removeDomainCookie, setDomainCookie } from '@/utils/cookie';
import { create } from 'zustand';
import { persist, subscribeWithSelector } from 'zustand/middleware';

type School = { id: string; name: string };

export type FsCurrentSubject = { id: string; name: string };

interface UserState {
  id: string;
  name: string;
  schools: School[];
  currentSchoolId: string;
  prefer: boolean;
  unit?: number;
  section?: number;
  /**
   * FS 平台的账号当前学科（服务端教材档案的 is_current 行，由 FsCurrentSubjectSync 写入）；
   * 外壳把它当作站点学科的等价物使用，名称由学科字典补齐、可能短暂为空串
   */
  currentSubject?: FsCurrentSubject;
  isFilled: () => boolean;
  reset: () => void;
}

const initialState = {
  id: '',
  name: '',
  picture: '',
  schools: [],
  currentSchoolId: '',
  prefer: false,
  unit: undefined,
  section: undefined,
  currentSubject: undefined,
};

const USER_COOKIE_KEY = 'user_store';

const useUserStore = create<UserState>()(
  persist(
    subscribeWithSelector((set, get) => ({
      ...initialState,

      isFilled: () => Boolean(get().id),
      reset: () => set({ ...initialState }),
    })),
    { name: 'user_store' },
  ),
);

useUserStore.subscribe(
  (state) => [state.id],
  ([id]) => {
    Monitoring.setConfig({
      uin: id,
    });
    EventTracker.setUser(id);
  },
);

useUserStore.subscribe(
  (state) => ({
    id: state.id,
    name: state.name,
    currentSchoolId: state.currentSchoolId,
  }),
  (slice) => {
    if (slice.id) {
      setDomainCookie(USER_COOKIE_KEY, JSON.stringify(slice));
    } else {
      removeDomainCookie(USER_COOKIE_KEY);
    }
  },
);

// persist 的 localStorage 恢复发生在订阅注册之前，恢复本身不会触发订阅；
// 冷启动时在此主动补写一次 cookie，保证任何入口进入时 cookie 就绪。
const { id, name, currentSchoolId } = useUserStore.getState();
if (id) {
  setDomainCookie(
    USER_COOKIE_KEY,
    JSON.stringify({ id, name, currentSchoolId }),
  );
}

export default useUserStore;
